module.exports = __webpack_public_path__ + "img/bluedanger.861dbe2c.svg";